/**
 * Выбирает источник данных для селекта категорий расходов.
 */
export function expenseCategorySelectItems({
  selectItems = [],
  expenseCategories = [],
  isSearchActive = false,
} = {}) {
  if (isSearchActive) return selectItems;

  return selectItems.length > 0 ? selectItems : expenseCategories;
}
